
import PropTypes from "prop-types";
import React from "react";
import "./style.css";
import { Link } from "react-router-dom";

export const ButtonLarge = ({ className, text = "Explore the talent", divClassName = "", linkTo="/", target="_self", callBackFunction, disabled=false}) => {

  switch (target) {
    case "button":
      return (
          <input type="button" disabled={disabled} value={text} className={` button-large ${className} form-button ${divClassName}`} onClick={callBackFunction} />
      );
      break;
    case "_blank":
        return (
            <a href={linkTo}  target="_blank" rel="noreferrer">
              <div className={`button-large ${className}`}>
                <div className={`explore-the-talent ${divClassName}`}>{text}</div>
              </div>
            </a>
          );
      break;
    default:
      return (
        <Link to={linkTo} reloadDocument>
        <div className={`button-large ${className}`}>
          <div className={`explore-the-talent ${divClassName}`}>{text}</div>
        </div>
        </Link>
      );
      break;
  }

};

ButtonLarge.propTypes = {
  text: PropTypes.string,
};
